export default __webpack_public_path__ + "static/media/close.e336b279.svg";